"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Paper"));



//////////////////
// WEBPACK FOOTER
// ./src/components/Paper/index.ts
// module id = 320
// module chunks = 0